import { m } from 'framer-motion';

import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

import { SimpleLayout } from 'src/layouts/simple';
import { DashboardLayout } from 'src/layouts/dashboard';
import { ForbiddenIllustration } from 'src/assets/illustrations';

import { varBounce, MotionContainer } from 'src/components/animate';

// ----------------------------------------------------------------------

type ForbiddenViewProps = {
  /** 返回路径，默认商户后台首页 */
  backHref?: string;
  /** 内嵌于后台布局时使用，不套 SimpleLayout */
  embedded?: boolean;
};

/** 403 无权访问页面 */
export function ForbiddenView({ backHref, embedded = false }: ForbiddenViewProps) {
  const router = useRouter();

  const handleBack = () => {
    router.replace(backHref ?? paths.dashboard.root);
  };

  const renderContent = (
    <>
      <m.div variants={varBounce('in')}>
        <Typography variant="h3" sx={{ mb: 2 }}>
          无权访问
        </Typography>
      </m.div>

      <m.div variants={varBounce('in')}>
        <Typography sx={{ color: 'text.secondary', mb: 3 }}>
          您没有访问此页面的权限，请联系管理员分配相应角色权限。
        </Typography>
      </m.div>

      <m.div variants={varBounce('in')}>
        <ForbiddenIllustration sx={{ my: { xs: 5, sm: embedded ? 8 : 10 } }} />
      </m.div>

      <m.div variants={varBounce('in')}>
        <Button variant="contained" onClick={handleBack}>
          返回首页
        </Button>
      </m.div>
    </>
  );

  if (embedded) {
    return (
      <Container component={MotionContainer} sx={{ py: 10, textAlign: 'center' }}>
        {renderContent}
      </Container>
    );
  }

  return (
    <SimpleLayout slotProps={{ content: { compact: true } }}>
      <Container component={MotionContainer} sx={{ textAlign: 'center' }}>
        {renderContent}
      </Container>
    </SimpleLayout>
  );
}
